export const Loader = ({ ...props }) => {
  const getLoaderAsset = () => {
    switch (props.color) {
      case 'accent':
        return '/gifs/Loader_PM.gif';
      default:
        return '/gifs/Loader_NB.gif';
    }
  };

  return <img src={getLoaderAsset()} className="h-10" {...props}></img>;
};

export default Loader;
